export const phoneStyles: {
  width: number;
  height: number;
  header: number;
  footer: number;
  body: number;
  keypadHeight: number;
  ivrHeight: number;
  draggableHeaderHeight: number;
  incomingMinHeight: number;
  inCallMinHeight: number;
  rejectMessageHeight: number;
  waitingCallBarHeight: number;
  waitingCallBarHeaderHeight: number;
  waitingCallBarGap: number;
  queuePanelWidth: number;
  queuePanelGap: number;
  queuePanelMinimizedHeight: number;
} = Object();
phoneStyles.width = 332;
phoneStyles.height = 590;
phoneStyles.header = 62;
phoneStyles.footer = 60;
phoneStyles.body = phoneStyles.height - (phoneStyles.header + phoneStyles.footer);
phoneStyles.keypadHeight = 348;
phoneStyles.ivrHeight = 320;
phoneStyles.draggableHeaderHeight = 40;
phoneStyles.incomingMinHeight = 134;
phoneStyles.inCallMinHeight = 144;
phoneStyles.rejectMessageHeight = 44;
phoneStyles.waitingCallBarHeaderHeight = 48;
// waiting (second) call bar: header (48) + action row (72). The bar is stacked inside the draggable
// phone column, so its height has to be known up front to keep the whole column in the viewport.
phoneStyles.waitingCallBarHeight = phoneStyles.waitingCallBarHeaderHeight + 72;
phoneStyles.waitingCallBarGap = 8;
phoneStyles.queuePanelWidth = 300;
phoneStyles.queuePanelGap = 8;
phoneStyles.queuePanelMinimizedHeight = 360;

export const phoneModes = {
  dialer: 'dialer',
  incoming: 'incoming',
  inCall: 'in-call',
  transferCall: 'transfer-call',
} as const;
